
import  { create } from 'zustand';

const currentPageStore =  create((set,get) => ({
    currentPage: '', 
    setCurrentPage: (value) => set({currentPage: value})
})); 


export default currentPageStore